import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const FirstStageCategoriesFilter = ({
    firstStageCategories = [],
    loading,
    filters,
    restoreFilterValues,
    onChangeValue = () => {},
    hidden = false,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='firstStageCategories'
        hidden={hidden}
        options={firstStageCategories}
        disabled={loading}
        placeholder='1st stage category'
        loading={loading}
        setValue={restoreFilterValues(filters, 'firstStageCategories')}
        multiple
        selection
        search
        onChangeValue={onChangeValue}
    />
);

FirstStageCategoriesFilter.propTypes = {
    firstStageCategories: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func,
    hidden: PropTypes.bool,
};
